// NOTE: CSS is enqueued separately by WordPress (style.scss is its own Vite
// entry), so it is intentionally NOT imported here.

import { gsap } from 'gsap'

import { initGlobals } from './setup/globals'
import { initResize } from './setup/resize'
import { initComponents } from './setup/components'
import { initScrollTrigger } from './setup/scroll-trigger'
import { initSwup } from './setup/swup'
import { initViewManager } from './setup/view-manager'
import { initPageReveal } from './setup/page-reveal'

// Opt-in smooth scroll (off by default). See src/js/README.md.
// import { initLenis } from './setup/lenis'
// import { initScrollSmoother } from './setup/scroll-smoother'

// -----------------------------------------------------------------------------
// Phase 1 — construct. No DOM queries here. Lines are in dependency order.
// -----------------------------------------------------------------------------
const ctx = initGlobals() // breakpoints, browser, eventBus; sets window.app
initResize(ctx) // ctx.resize; window resize -> Events.PAGE_RESIZE
initComponents(ctx) // ctx.componentsManager (registers; mounts in Phase 2)
initScrollTrigger(ctx) // ctx.scrollTriggerManager
initSwup(ctx) // ctx.swup
initViewManager(ctx) // depends on ctx.componentsManager + ctx.swup
const { runPageReveal } = initPageReveal(ctx) // depends on ctx.swup
ctx.runPageReveal = runPageReveal

// -----------------------------------------------------------------------------
// Phase 2 — start. DOM-dependent work, run once after the DOM is ready.
// -----------------------------------------------------------------------------
const start = () => {
	ctx.componentsManager.init() // query + mount components
	ctx.viewManager.mount() // resolve root, bind listeners
	ctx.runPageReveal('direct')

	hidePageLoader()
}

const hidePageLoader = () => {
	const el = document.querySelector('.js-overlay-loader')
	if (!el) return

	gsap.fromTo(
		el,
		{ opacity: 1 },
		{
			opacity: 0,
			duration: 0.25,
			delay: 0.3,
			onComplete: () => gsap.set(el, { display: 'none' }),
		},
	)
}

document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start, { once: true }) : start()
